<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_ii"><strong><span class="small">BOOKS BY SALLY HELGESEN</span></strong></a></p><a id="page_ii">
<p class="noindent1"><em>The Female Advantage: Women’s Ways of Leadership</em></p>
<p class="noindenta"><em>The Web of Inclusion: A New Architecture for Building Great<br/>Organizations</em></p>
<p class="noindenta"><em>Thriving in 24/7: Six Strategies for Taming the New World<br/>of Work</em></p>
<p class="noindenta"><em>Everyday Revolutionaries: Working Women and the<br/>Transformation of American Life</em></p>
<p class="noindenta"><em>Wildcatters: A Story of Texans, Oil, and Money</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?66aaf213